import { AppState } from 'Store'

const selectEntries = (state: AppState) => state.bankEmployees.data.entries
const selectCurrentParams = (state: AppState) => state.bankEmployees.requestParams
const selectTotal = (state: AppState) => state.bankEmployees.data.total_entries
const selectIsLoading = (state: AppState) => state.bankEmployees.isLoading
const selectAll = (state: AppState) => state.bankEmployees.data
const selectSubstitutionInfo = (state: AppState) => state.bankEmployees.substitutionInfo
const selectSubstitution = (state: AppState) =>
	state.bankEmployees.substitutionInfo?.my_substitution
const selectSubstitutes = (state: AppState) =>
	state.bankEmployees.substitutionInfo?.users_i_substitute
const selectSubstitutesCount = (state: AppState) =>
	state.bankEmployees.substitutionInfo?.users_i_substitute_count
const selectStatus = (state: AppState) => state.bankEmployees.substitutionInfo?.user_status

export const bankEmployeesSelectors = {
	selectEntries,
	selectTotal,
	selectCurrentParams,
	selectIsLoading,
	selectAll,
	selectSubstitutionInfo,
	selectSubstitution,
	selectSubstitutes,
	selectSubstitutesCount,
	selectStatus,
}
